// extracted by mini-css-extract-plugin
export default {"imgdiv":"f54bdf3a59 d96bea063b","img":"_623c538389 _06cb83fc70"};